<template>
  <div style="height: 600px;position:relative">
    <div class="vertical">
      <sj-tooltip placement="bottom-start" theme="light">
        <span slot="reference">下左tooltips</span>
        <div slot="tooltips">tooltipstooltipstooltipstooltipstooltips</div>
      </sj-tooltip>
      <sj-tooltip placement="bottom">
        <span slot="reference">下方tooltips</span>
        <div slot="tooltips">提示文字提示文字提示文字提示文字</div>
      </sj-tooltip>
      <sj-tooltip placement="bottom-end">
        <span slot="reference">下右tooltips</span>
        <div slot="tooltips">提示文字提示文字提示文字提示文字</div>
      </sj-tooltip>
    </div>
    <div class="horizontal">
      <sj-tooltip placement="right-start" size="large">
        <span slot="reference">右上tooltips，大</span>
        <div slot="tooltips">提示文字提示文字提示文字提示文字</div>
      </sj-tooltip>
      <sj-tooltip placement="left-start" size="large">
        <span slot="reference">左上tooltips，大</span>
        <div slot="tooltips">提示文字提示文字提示文字提示文字</div>
      </sj-tooltip>
    </div>
    <div class="horizontal">
      <sj-tooltip placement="right">
        <span slot="reference">右侧tooltips</span>
        <div slot="tooltips">提示文字提示文字提示文字提示文字</div>
      </sj-tooltip>
      <sj-tooltip placement="left">
        <span slot="reference">左侧tooltips</span>
        <div slot="tooltips">提示文字提示文字提示文字提示文字</div>
      </sj-tooltip>
    </div>
    <div class="horizontal">
      <sj-tooltip placement="right-end">
        <span slot="reference">右下tooltips</span>
        <div slot="tooltips">提示文字提示文字提示文字提示文字</div>
      </sj-tooltip>
      <sj-tooltip placement="left-end">
        <span slot="reference">左下tooltips</span>
        <div slot="tooltips">提示文字提示文字提示文字提示文字</div>
      </sj-tooltip>
    </div>
    <div class="vertical">
      <sj-tooltip placement="top-start">
        <span slot="reference">上左tooltips</span>
        <div slot="tooltips">提示文字提示文字提示文字提示文字</div>
      </sj-tooltip>
      <sj-tooltip placement="top">
        <span slot="reference">上方tooltips</span>
        <div slot="tooltips">提示文字提示文字提示文字提示文字</div>
      </sj-tooltip>
      <sj-tooltip placement="top-end">
        <span slot="reference">上右tooltips</span>
        <div slot="tooltips">提示文字提示文字提示文字提示文字</div>
      </sj-tooltip>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.vertical {
  height: 22%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.horizontal {
  height: 20%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
